export type JsonLdSchemaBlock = {
  id?: string | number;
  name?: string | null;
  content?: string | Record<string, unknown> | null;
  order?: number;
};

export type NormalizedJsonLdSchema = {
  id?: string | number;
  name: string | null;
  content: string;
  order: number;
};

export const getJsonLdDefaults = (
  schemas?: JsonLdSchemaBlock[] | null | unknown,
): NormalizedJsonLdSchema[] => {
  if (!Array.isArray(schemas)) return [];

  return schemas.map((schema, index) => ({
    ...(schema?.id ? { id: schema.id } : {}),
    name: schema?.name ?? "",
    content:
      typeof schema?.content === "string"
        ? schema.content
        : JSON.stringify(schema?.content ?? "", null, 2),
    order: typeof schema?.order === "number" ? schema.order : index,
  }));
};

export const normalizeJsonLdSchemas = (
  schemas?: JsonLdSchemaBlock[] | null | unknown,
): NormalizedJsonLdSchema[] =>
  (Array.isArray(schemas) ? schemas : []).map((schema, index) => ({
    ...(schema?.id ? { id: schema.id } : {}),
    name: schema?.name?.trim() || null,
    content: typeof schema?.content === "string" ? schema.content : "",
    order: index,
  }));

export const validateJsonLdSchemas = (
  schemas: JsonLdSchemaBlock[] = [],
  setError: (path: string, error: { type: string; message: string }) => void,
) => {
  let firstInvalidIndex = -1;

  schemas.forEach((schema, index) => {
    const value =
      typeof schema?.content === "string" ? schema.content.trim() : "";

    if (!value) {
      setError(`json_ld.${index}.content`, {
        type: "manual",
        message: "Schema cannot be empty",
      });
      if (firstInvalidIndex === -1) firstInvalidIndex = index;
      return;
    }

    try {
      JSON.parse(value);
    } catch {
      setError(`json_ld.${index}.content`, {
        type: "manual",
        message: "Must be valid JSON",
      });
      if (firstInvalidIndex === -1) firstInvalidIndex = index;
    }
  });

  return {
    isValid: firstInvalidIndex === -1,
    firstInvalidIndex,
    normalizedSchemas: normalizeJsonLdSchemas(schemas),
  };
};
